<template>
  <div :class="{'c-area': true, 'c-area--printing': $store.state.printToPdfInProgress}">
    <div class="row">
      <div :class="{'col-6': $store.state.printToPdfInProgress, 'col-12': !$store.state.printToPdfInProgress}">
        <base-panel
          :additional-classes="additionalClasses"
        >
          <div
            :class="{'currently-editing__row': true, 'row': true, 'min-height-override': !$store.state.currentlyEditing.includes(element.id)}"
            :style="siblingStyle"
          >
            <div
              :class="{'col-sm-12': true, 'currently-editing__column': $store.state.currentlyEditing.includes(element.id)}"
            >
              <base-panel
                :additional-classes="panelClass"
                additional-heading-classes="ed_panel_heading_actionbar"
              >
                <template #heading>
                  <app-elements-area-heading
                    :content-pool-parent-id="parentId"
                    :element="element"
                    :identifier="identifier"
                    @delete:self="$emit('delete:self', $event)"
                  />
                </template>
                <div v-if="$store.state.currentlyEditing.includes(element.id) && !$store.state.printToPdfInProgress" class="app-area-settings">
                  <slot />
                </div>
                <app-elements-area-wireframe
                  :area-id="element.id"
                  :element="element"
                  :identifier="identifier"
                  :number-of-areas="numberOfAreas"
                  :show="($store.state.showWireframes && parseInt(element.disabled) !== 1) || $store.state.currentlyEditing.includes(element.id)"
                />
              </base-panel>
            </div>
          </div>
        </base-panel>
      </div>
      <div
        v-if="$store.state.printToPdfInProgress"
        class="col-6"
      >
        <span
          :class="{'pdf-text': $store.state.printToPdfInProgress}"
          style="color: #2f9590; font-size: 0.6em"
        >Platz für Notizen:</span>
      </div>
    </div>
  </div>
</template>

<script>
import AppElementsAreaHeading from '@/components/AppElementsAreaHeading.vue'
import AppElementsAreaWireframe from '@/components/AppElementsAreaWireframe.vue'
import BasePanel from '@/components/BasePanel.vue'

export default {
  /**
   * Die Komponente zur Darstellung von Areas. Sie entspricht dem Vorkommen her den AppInput... Komponenten, erlaubt aber
   * keine tatsächliche Dateneingabe. Später wird sie wohl die Logik fürs löschen und de-/aktivieren einer Area handhaben.
   * @displayName AppMarkupArea
   */
  name: 'AppMarkupArea',
  components: {
    AppElementsAreaHeading,
    AppElementsAreaWireframe,
    BasePanel
  },
  props: {
    /**
     * Das konfigurierte Datenobjekt für das Feld das dargestellt werden soll
     */
    element: {
      type: Object,
      required: true
    },
    /**
     * Der Key des konfigurierten Datenobjekts für das Feld das dargestellt werden soll
     */
    identifier: {
      type: String,
      required: true
    },
    /**
     * Welche Klasse soll das Panel bekommen?
     */
    panelClass: {
      type: String,
      required: true
    },
    parentId: {
      type: Number,
      required: true
    },
    numberOfAreas: {
      type: Number,
      required: true
    }
  },
  emits: ['update:siblings', 'update:self', 'delete:self'],
  data() {
    return {
      siblingStyle: {},
    }
  },
  computed: {
    additionalClasses() {
      let string = '';

      if (!this.$store.state.currentlyEditing.includes(this.element.id)) {
        string = string + ' panel--invisible'
      }

      if (this.$store.state.currentlyEditing.includes(this.element.id)) {
        string = string + ' panel--focus'
      }

      return string
    }
  },
  methods: {
    toggle() {
      if (this.$store.state.currentlyEditing.includes(this.element.id)) {
        this.$store.commit('stopEditing', this.element.id);
      }
      else {
        this.$store.commit('startEditing', this.element.id);
      }
    }
  }
}
</script>

<style lang="less">
.currently-editing {
  &__row {
    position: relative;
  }
}

.min-height-override {
  min-height: 0 !important;
}

.show-content-btn {
  width: 100px;
  height: 100px;

  position: absolute;
  top: 50%;
  margin-top: -50px;
  left: 0;

  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 4rem;
  cursor: pointer;
}

.app-area-settings {
  position: absolute;
  top: 30px;
  right: 13px;
  text-align: right;
  padding: 10px 0 0 10px;

  fieldset {
    text-align: left;
  }

  @media (max-width: 991px) {
    position: static;
  }
}

.panel--focus {
  margin-bottom: 0;

  .panel-body {
    padding: 0px;
  }
}

.c-area {
  &--printing {
    margin-bottom: -10px;
  }

  .item_groups {
    width: 40px;
    position: absolute;
    right: -19px;
    top: 100%;
  }
}
</style>